import { RadioGroup, Span } from "@icg360/design-system";

import { MultiStepFormLayout } from "components/multi-step-form-layout";
import { NO_POOL_STEP_COUNT, type PoolType } from "consts";
import { useMultiStepFormState } from "hooks/use-multi-step-form-state";

import {
  PropertyUpdatePoolContext,
  type PropertyUpdatePoolContextState,
} from ".";
import styles from "./property-update-pool.module.scss";

export const PropertyPoolType = () => {
  const { formNavigate, state, setFields } =
    useMultiStepFormState<PropertyUpdatePoolContextState>(
      PropertyUpdatePoolContext
    );

  // Initialize for poolType: "None"
  let nextPath = "proof";
  if (state?.poolType === "In-ground") {
    nextPath = "fence";
  } else if (state?.poolType === "Above-ground") {
    nextPath = "board-slide";
  }

  return (
    <MultiStepFormLayout
      step={1}
      totalSteps={NO_POOL_STEP_COUNT}
      heading="Do you have a swimming pool on the property?"
      buttonProps={{
        primary: {
          disabled: !state?.poolType,
          path: `/my/property/pool/${nextPath}`,
          text: "Next",
        },
        cancel: { path: "/my/property" },
        back: { hide: true },
        formNavigate,
      }}
    >
      <RadioGroup
        aria-label="Pool type options"
        className={styles.radioGroupDS}
        defaultValue={state?.poolType}
        onChange={(value: PoolType) => setFields({ poolType: value })}
      >
        <RadioGroup.Card title="Yes, an in-ground pool" value="In-ground" />
        <RadioGroup.Card
          title="Yes, an above-ground pool"
          value="Above-ground"
        />
        <RadioGroup.Card title="No" value="None" />
      </RadioGroup>
      <Span color="quiet">
        If you have any additional questions about how we can support you and
        give you the best coverage for your pool, please reach out to your
        insurance representative.
      </Span>
    </MultiStepFormLayout>
  );
};
